import Departments from '../../common/models/Departments';

const isCategoryNonDescriptive = ({ categoryName }) =>
  !categoryName ||
  Object.keys(Departments.namesCategoryNonDescriptiveSeo)
    .map(name => name.toLocaleString())
    .includes(categoryName.toLowerCase());

const overrideCategory = (department, categoryName) => {
  const departmentFormatted = department.replace(/-/g, ' ').toLowerCase();
  if (departmentFormatted === categoryName.toLowerCase()) {
    return 'Clothing';
  }
  return categoryName;
};

const productList = {
  title: ({ categoryName, department }) => {
    if (isCategoryNonDescriptive({ categoryName })) {
      return `Shop italist | Best price for designer luxury brands for ${Departments.getName(department)}`;
    }

    return `Shop ${Departments.getNameAsPossessiveNoun(department)} ${overrideCategory(
      department,
      categoryName
    )} at italist | Best price in the market`;
  },
  description: ({ categoryName, department }) => {
    const highestLevelDepartment = Departments.getKidsDepartmentsInternalNames().includes(department)
      ? Departments.getKidsInternalName()
      : department;

    if (isCategoryNonDescriptive({ categoryName })) {
      return `Looking for a wide selection of ${Departments.getNameAsPossessiveNoun(
        highestLevelDepartment
      ).toLowerCase()} luxury? Shop at italist: Over 200,000 items to choose from, up to 30% cheaper and express shipped. Find 1,000 worldwide luxury brands with designer clothes, shoes, bags & accessories.`;
    }

    return `Shop at italist: the largest selection of ${Departments.getNameAsPossessiveNoun(
      department
    ).toLowerCase()} ${overrideCategory(
      department,
      categoryName
    ).toLowerCase()} from Italy’s finest stores. EXPRESS international shipping!`;
  }
};

export default productList;
